import CssBaseline from "@mui/material/CssBaseline";
import AppTheme from "../theme/AppTheme";
import AppAppBar from "../components/AppAppBar";
import Footer from "../components/Footer";
import PartnershipsSection from "../components/Partnerships";
import FloatingSocialButtons from "../components/FloatingSocialButtons";

export default function Partnerships(props: { disableCustomTheme?: boolean }) {
  return (
    <AppTheme {...props}>
      <CssBaseline enableColorScheme />

      <AppAppBar />
      <FloatingSocialButtons />
      <div>
        <PartnershipsSection />
        <Footer />
      </div>
    </AppTheme>
  );
}
